module.exports = __webpack_public_path__ + "static/media/billet.5728fcf7.png";